export default `<div>
<div style="text-align: center; padding-top: 80px;">
<strong>Document Parser</strong> is the powerful
<strong>document parsing</strong> engine that reads text,
fields, checkboxes from PDF and scaned documents. Best of
all, you can create extraction templates with
<strong>no coding</strong> required! Output comes as
structured JSON, CSV, XML. Cloud and on-prem versions are
available.
</div>
</div>`;
